"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUsaStateByZipVerification = void 0;
var _useRequest2 = require("./useRequest");
var _endpoints = require("./endpoints");
var _lodash = require("lodash");
var _useModalState = require("./useModalState");
var _AuthProvider = require("../shared/AuthProvider");
var useUsaStateByZipVerification = function useUsaStateByZipVerification(_ref) {
  var isOutOfCountry = _ref.isOutOfCountry,
    _ref$onSuccess = _ref.onSuccess,
    _onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _lodash.noop : _ref$onError;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    patient = _useAuth.user;
  var stateByZipModal = (0, _useModalState.useModalState)();
  var _useRequest = (0, _useRequest2.useRequest)(function (zipCode) {
      return (0, _endpoints.getUsaStateByZipUrl)(zipCode);
    }, {
      manual: true,
      onSuccess: function onSuccess(stateByZip) {
        var verificationRequired = isOutOfCountry ? false : patient.profile.state !== stateByZip;
        if (verificationRequired) {
          stateByZipModal.show();
        } else {
          _onSuccess();
        }
      },
      onError: onError
    }),
    onVerify = _useRequest.run,
    stateByZip = _useRequest.data;
  return {
    onVerify: onVerify,
    stateByZipModal: stateByZipModal,
    stateByZip: stateByZip
  };
};
exports.useUsaStateByZipVerification = useUsaStateByZipVerification;